export default "__VITE_ASSET__Ccdr0rJV__"